/**
 *
 * @template IType
 * @template OType
 * @param {IType[]} array
 * @param {(sourceObject: IType) => OType} translateObjectMethod
 * @return {OType[]}
 */
const translateObjectArray = (array, translateObjectMethod) => {
  if (!array)
    throw new Error("array does not exist");

  if (typeof array === 'string')
    throw new Error("strings are not arrays");

  if (!(typeof array.length === 'number' && Number.isInteger(array.length) && array.length >= 0))
    throw new Error("object is not array-like");

  return Array.from(array, translateObjectMethod);
}

export {translateObjectArray};
